import { LocalStateNotifications } from './Notifications.types'

export const NotificationsDefaultLocalState: LocalStateNotifications = {
  expandedId: null,
  filter: { textSearchFilter: '' },
}
